import { render, staticRenderFns } from "./PaymentErrorBar.vue?vue&type=template&id=0b7c8de2&scoped=true"
import script from "./PaymentErrorBar.vue?vue&type=script&lang=js"
export * from "./PaymentErrorBar.vue?vue&type=script&lang=js"
import style0 from "./PaymentErrorBar.vue?vue&type=style&index=0&id=0b7c8de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c8de2",
  null
  
)

export default component.exports